<div class="animated-border-wrapper">
  <svg class="animated-border-wrapper__svg" preserveAspectRatio="none">
    <defs>
      <linearGradient id="rotating-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" class="stop-color-1" />
        <stop offset="25%" class="stop-color-2" />
        <stop offset="50%" class="stop-color-3" />
        <stop offset="75%" class="stop-color-4" />
        <stop offset="100%" class="stop-color-1" />
      </linearGradient>
    </defs>
    <rect
      class="animated-border-wrapper__rect"
      x="3"
      y="3"
      rx="4"
      ry="4"
      fill="none"
      stroke="url(#rotating-gradient)"
      stroke-width="6"
    />
  </svg>
  <div class="animated-border-wrapper__content">
    <ng-content></ng-content>
  </div>
</div>
